import {DocumentDownload} from "../model/document-download";
import {Observable} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";

export class FileUtils {

  static downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  static convertToBlob(supportDocument: DocumentDownload): Blob {
    return FileUtils.base64ToBlob(supportDocument.fileBytes, supportDocument.mimeType);
  }

  static base64ToBlob(base64: string, mimeType?: string): Blob {
    const deserialized = atob(base64);
    const bytes = new Uint8Array(deserialized.length);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = deserialized.charCodeAt(i);
    }
    return new Blob([bytes], mimeType ? {type: mimeType} : undefined);
  }

  static handleBlobError(error: any): Observable<any> {
    if (error.error instanceof Blob) {
      const reader: FileReader = new FileReader();
      const obs = new Observable((observer: any) => {
        reader.onloadend = () => {
          observer.error(new HttpErrorResponse({
            error: reader.result,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText,
            url: error.url
          }));
        };
      });
      reader.readAsText(error.error);
      return obs;
    } else {
      return new Observable((observer: any) => {
        observer.error(new HttpErrorResponse({
          error: error.message,
          headers: error.headers,
          status: error.status,
          statusText: error.statusText,
          url: error.url
        }));
      });
    }
  }

}
